export default "__VITE_ASSET__CFYjy9zK__"